module.exports = __webpack_public_path__ + "img/lordsmobile.b392a54.jpg";